module.exports = __webpack_public_path__ + "static/media/div1goldWin.808051bb.jpg";